import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

export const CODIGO_ENTREGA_MAX_LINEAS_VISIBLES = 15;

const syntaxStyle = {
  margin: 0,
  padding: '1rem',
  borderRadius: '8px',
  fontSize: '0.875rem',
};

const codeTagProps = { style: { fontFamily: 'Consolas, Monaco, Courier New, monospace' } };

const EXTENSION_POR_LENGUAJE = {
  python: 'py',
  javascript: 'js',
  typescript: 'ts',
  html: 'html',
  markup: 'html',
  css: 'css',
  json: 'json',
  sql: 'sql',
  java: 'java',
  c: 'c',
  cpp: 'cpp',
  php: 'php',
  ruby: 'rb',
  go: 'go',
  plaintext: 'txt',
};

const extensionParaLenguaje = (lang) =>
  EXTENSION_POR_LENGUAJE[String(lang || 'plaintext').toLowerCase()] || 'txt';

const descargarCodigo = (texto, language, nombreArchivo) => {
  const ext = extensionParaLenguaje(language);
  const blob = new Blob([texto], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo || `codigo.${ext}`;
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Muestra código de una entrega; si supera maxLineas, queda colapsado con "Ver más".
 */
const CodigoEntregaViewer = ({
  codigo,
  language = 'plaintext',
  maxLineas = CODIGO_ENTREGA_MAX_LINEAS_VISIBLES,
  nombreArchivo,
}) => {
  const [expandido, setExpandido] = useState(false);
  if (!codigo || !String(codigo).trim()) return null;

  const texto = String(codigo);
  const lineas = texto.split('\n');
  const ocultarResto = lineas.length > maxLineas;
  const codigoMostrar = ocultarResto && !expandido ? lineas.slice(0, maxLineas).join('\n') : texto;
  const lineasOcultas = lineas.length - maxLineas;

  return (
    <div className="codigo-entrega-viewer">
      <div
        className={`tareas-correccion-codigo-wrap codigo-entrega-viewer-wrap${
          ocultarResto && !expandido ? ' codigo-entrega-viewer-wrap--colapsado' : ''
        }`}
      >
        <SyntaxHighlighter
          language={language}
          style={oneDark}
          customStyle={syntaxStyle}
          codeTagProps={codeTagProps}
          showLineNumbers={lineas.length > 3}
        >
          {codigoMostrar}
        </SyntaxHighlighter>
      </div>
      <div className="codigo-entrega-viewer-actions">
        {ocultarResto && (
          <button
            type="button"
            className="codigo-entrega-viewer-toggle"
            onClick={() => setExpandido((v) => !v)}
            aria-expanded={expandido}
          >
            {expandido
              ? 'Ver menos'
              : `Ver más (${lineasOcultas} línea${lineasOcultas === 1 ? '' : 's'} oculta${lineasOcultas === 1 ? '' : 's'})`}
          </button>
        )}
        <button
          type="button"
          className="codigo-entrega-viewer-descargar"
          onClick={() => descargarCodigo(texto, language, nombreArchivo)}
        >
          ⬇ Descargar código
        </button>
      </div>
    </div>
  );
};

export default CodigoEntregaViewer;
